module.exports = __webpack_public_path__ + "static/media/card-UAP.4872af4b.svg";